import totalscreenType from "./totalscreenType";

export default function screenFinder(value) {
  return totalscreenType.find((item) => item.type === value);
}
